<template>
  <div class="cv-optimization-container">
    <div
      v-if="optimizationStatus === 'loading' || optimizationStatus === 'error'"
      class="optimization-loading"
    >
      <template v-if="optimizationStatus === 'loading'">
        <span>内容润色中，请稍后...</span>
      </template>
      <div
        class="flex flex-col"
        v-else
      >
        <div class="error-tips">AI 开小差了，请重新生成试试</div>
        <div
          class="retry-btn"
          @click="handleClickAiOptimization"
        >
          <i class="iconfont iconhuanyihuan"></i>
          重新润色
        </div>
      </div>
      <!-- <i
        class="iconfont iconclose"
        @click="handleCloseOptimization"
      ></i> -->
    </div>
    <div
      v-else-if="optimizationStatus === 'over'"
      class="optimization-result-content"
    >
      <div class="optimization-header">
        <div class="desc-content">
          <!-- <img
            class="logo"
            src="https://logo.wondercv.com/banners/33KGUVOwLyzHmma.png"
            alt=""
          /> -->
          <span class="txt">🌟 内容润色完成</span>
        </div>
      </div>
      <div
        v-if="isMemberAccount"
        class="optimization-content"
        v-html="optimizationResult"
      ></div>
      <div
        v-else
        class="normal-content flex justify-center items-center"
        :style="{
          backgroundImage: `url(${images[personInfo.theme]})`,
        }"
      >
        <div
          class="common-btn"
          @click="handleOpenMemberDialog"
        >
          开通会员查看结果
        </div>
      </div>
      <div class="flex items-center button-group">
        <button
          class="btn-item flex-1 flex justify-center items-center"
          @click="handleClickAiOptimization"
        >
          <i class="iconfont iconhuanyihuan1"></i>
          重新润色
        </button>
        <button
          v-if="isMemberAccount"
          class="btn-item flex-1 flex justify-center items-center"
          @click="useOptimizationContent"
        >
          <i class="iconfont iconFrame1"></i>
          使用当前内容
        </button>
        <button
          v-else
          class="btn-item flex-1 flex justify-center items-center"
          @click="handleOpenMemberDialog"
        >
          <i class="iconfont iconFrame1"></i>
          开通会员使用内容
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import CompleteButton from '../CompleteButton/CompleteButton.vue';
export default {
  components: {
    CompleteButton,
  },
  props: {
    description: {
      type: String,
      default: '',
    },
    optimizationStatus: {
      type: String,
      default: 'initial',
    },
    optimizationResult: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      images: {
        dark: 'https://logo.wondercv.com/banners/6m4zV2GEicU0O0P.png',
        light: 'https://logo.wondercv.com/banners/nzo5KU9MoITENLg.png',
      },
    };
  },
  computed: {
    ...mapState('me', ['personInfo', 'isMembership']),
    isMemberAccount() {
      return this.personInfo.is_membership;
    },
  },
  methods: {
    handleClickAiOptimization() {
      this.$emit('clickAiOptimization');
    },
    handleOpenMemberDialog() {
      this.$emit('saveForm');
      this.$emit('buyMember');
    },
    handleCloseOptimization() {
      this.$emit('closeOptimization');
    },
    async useOptimizationContent() {
      const confirm = await this.$wondercv.showConfirm({
        title: '是否使用当前润色内容？',
        content: 'AI生成后的内容可能还需要您自主微调哦',
        confirmText: '确认使用',
        cancelText: '我再想想',
      });
      if (confirm) {
        this.$emit('useOptimizationContent', this.optimizationResult);
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/assets/css/variable.scss';
.cv-optimization-container {
  width: 100%;
  padding-bottom: 18px;
  .optimization-loading {
    display: flex;
    align-items: center;
    position: relative;
    border-radius: 4px;
    color: $text-color;
    font-size: 16px;
    font-weight: 500;
    margin-top: 26px;
    .loading-icon {
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
    .iconclose {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 16px;
      font-size: 12px;
      cursor: pointer;
    }
    .retry-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 219px;
      height: 42px;
      border-radius: 6px;
      color: $text-color;
      border: 1px solid $advice-border-color;
      font-size: 12px;
      margin-top: 24px;
      cursor: pointer;
      .iconhuanyihuan {
        font-size: 12px;
        margin-right: 4px;
      }
    }
  }
  .optimization-result-content {
    .optimization-header {
      position: relative;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 48px;
      box-sizing: border-box;
      padding: 18px 0 16px;
      .desc-content {
        display: flex;
        align-items: center;
        .logo {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
        .txt {
          color: $text-color;
          font-size: 14px;
          font-weight: 500;
          font-size: 16px;
        }
      }
    }
    .optimization-content {
      min-height: 132px;
      font-size: 12px;
      line-height: 15px;
      overflow-x: hidden;
      color: $text-color;
      box-sizing: border-box;
      white-space: pre-line;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .normal-content {
      width: 100%;
      height: 108px;
      background-image: url('https://logo.wondercv.com/banners/6m4zV2GEicU0O0P.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      box-sizing: border-box;
      border-radius: 8px;
      .common-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 32px;
        background: linear-gradient(270deg, #e15d3f 0%, #febf5d 100%);
        color: #fff;
        border-radius: 999px;
        box-sizing: border-box;
        cursor: pointer;
        padding: 0 16px;
        width: max-content;
        &:hover {
          background-color: #ff8569;
        }
      }
    }
    .button-group {
      display: flex;
      gap: 16px;
      margin-top: 18px;
      .btn-item {
        color: $text-color;
        border: 1px solid $advice-border-color;
        border-radius: 6px;
        height: 42px;
        i {
          margin-right: 4px;
        }
      }
    }
  }
}
</style>
